import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["photoInput", "currentPhoto", "photoPreview", "previewImage", "photoForm", "photoFormInput"]

  previewPhoto(event) {
    const file = event.target.files[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = (e) => {
      this.previewImageTarget.src = e.target.result
      this.photoPreviewTarget.classList.remove("hidden")
      this.currentPhotoTarget.classList.add("hidden")
    }
    reader.readAsDataURL(file)
  }

  uploadPhoto() {
    const file = this.photoInputTarget.files[0]
    if (!file) return

    const dataTransfer = new DataTransfer()
    dataTransfer.items.add(file)
    this.photoFormInputTarget.files = dataTransfer.files
    this.photoFormTarget.requestSubmit()
  }

  cancelPreview() {
    this.photoPreviewTarget.classList.add("hidden")
    this.currentPhotoTarget.classList.remove("hidden")
    this.photoInputTarget.value = ""
  }
}
